import React, { useEffect, useRef, useState } from "react";
import DataTable from "../components/CaseLevelBillingDataTable";
import { CASEBILLINGHEADER } from "../actions/Constant";
import SearchInput from "../../../../common/InlineSearch";
import { useSelector } from "react-redux";
import Stack from "react-bootstrap/Stack";
import { Container } from "react-bootstrap";
import { getCaseLevelBillingList } from "../../../../services/BillingConfigApi";
import { RootState } from "../../../../redux/Store";
import TableRowsPerPage from "../../../../common/TableRowsPerPage";
import CustomPagination from "../../../../common/Pagination";
import { PageSizes } from "pdf-lib";

const CaseBillingList: React.FC<any> = ({ billingActiveTab, onRowSelect }) => {
  const loggedInUserid = useSelector((state: RootState) => state.auth.userid);
  const [billingData, setBillingData] = useState<any[]>([]);
  const [searchQuery, setSearchQuery] = useState<string>("");
  const [billingCount, setbillingCount] = useState<string>("");
  const [searchQuerylength, setSearchQuerylength] = useState<string>("");
  const searchInputRef = useRef<any>(null);
  const [filteredData, setFilteredData] = useState<any[]>([]);
  const [data, setData] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const caseDetails = useSelector((state: RootState) => state.caseHeader);
  const selectedCaseInfoId = caseDetails?.caseInfoId;
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [itemsPerPage, setItemsPerPage] = useState<number>(15);
  const [totalPages, setTotalPages] = useState<number>(1);
  const [totalRows, setTotalRows] = useState<any>("");
  const [selectedRowData, setSelectedRowData] = useState(null);

  useEffect(() => {
    if (billingActiveTab == "Case Billing List") {
      getDataForCaseLevelBilingList();
    }
  }, [billingActiveTab]);

  useEffect(() => {
    getDataForCaseLevelBilingList(searchQuery);
  }, [searchQuery, currentPage, itemsPerPage]);
  const handleRowsPerPageChange = (value: number) => {
    setItemsPerPage(value);
    setCurrentPage(1);
  };
  const paginate = (pageNumber: number) => {
    setCurrentPage(pageNumber);
    getDataForCaseLevelBilingList(searchQuery, pageNumber, itemsPerPage);
  };
  const handleSortAction = (row: any) => {
    getDataForCaseLevelBilingList(
      searchQuery,
      currentPage,
      itemsPerPage,
      row.key,
      row.direction
    );
  };

  const getDataForCaseLevelBilingList = async (
    query: string = "",
    pageNo: number = currentPage,
    pageSize: number = itemsPerPage,
    key: string = "",
    direction: string = "DESC"
  ) => {
    try {
      setLoading(true);

      const trimmedQuery = query?.trim();
      const payload = {
        caseInfoId: selectedCaseInfoId,
        searchString: trimmedQuery || "",
        loggedInUserId: loggedInUserid,
        pageNo,
        pageSize,
        sortColumn: key,
        sortOrder: direction,
      };

      const response = await getCaseLevelBillingList(payload);

      setBillingData(response);
      setTotalPages(response[0]?.totalPages || 1);
      setTotalRows(response[0]?.totalRecords || null);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleSearchQueryChange = (query: string) => {
    setSearchQuery(query);
    // fetchStakeholderdata(query, 1, itemsPerPage);
  };

  const handleSearchQueryChangeForlength = (query: string) => {
    setSearchQuerylength(query?.trim());
  };

  const handleReset = () => {
    searchInputRef.current?.clear();
    setSearchQuery("");
    setSearchQuerylength("");
  };

  const handleRowAction = (row: any, action: string) => {
    setSelectedRowData(row);
    handleReset();
    onRowSelect(row);
  };

  const entriesText = !totalRows
    ? "Showing 0 of 0 entries"
    : `Showing ${(currentPage - 1) * itemsPerPage + 1} to ${Math.min(
        currentPage * itemsPerPage,
        totalRows
      )} of ${totalRows} entries`;
  return (
    <div>
      <div className="d-flex justify-content-between align-items-center border-bottom pb-1 px-0 cancelappointment col mb-3 search_closer ">
        <h3 className="mr-2 me-auto">Billing List</h3>
        <SearchInput
          ref={searchInputRef}
          data={billingData}
          searchKeys={[]}
          onSearchResult={setBillingData}
          placeholder="Search"
          onSearchQueryChange={handleSearchQueryChange}
          onInputChange={handleSearchQueryChangeForlength}
        />
        <button
          onClick={handleReset}
          className="reset_btn"
          style={{
            background: "none",
            border: "none",
            cursor: "pointer",
            padding: "5px",
          }}
        >
          <span className="material-icons reset_ic0">restart_alt</span>
        </button>
        <div className="borderB mb-3"></div>
      </div>

      <DataTable
        headers={CASEBILLINGHEADER}
        rows={billingData}
        onSortAction={handleSortAction}
        onAction={handleRowAction}
      />
      <div className="d-flex justify-content-between align-items-center mt-0">
        <div className="col-md-12">
          <div className="row">
            <div className="col-md-6 showingData_wrapper">
              <span>{entriesText}</span>
            </div>
            <div className="col-md-6">
              <div className="d-flex flex-row-reverse ">
                <CustomPagination
                  currentPage={currentPage}
                  totalPages={totalPages}
                  onPageChange={paginate}
                />
                <TableRowsPerPage
                  value={itemsPerPage}
                  onSelect={handleRowsPerPageChange}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CaseBillingList;
